import { render, staticRenderFns } from "./ProductPriceDetails.vue?vue&type=template&id=69fe535c"
import script from "./ProductPriceDetails.vue?vue&type=script&lang=ts"
export * from "./ProductPriceDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports